import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModalDialogComponent } from './components/modal-dialog/modal-dialog.component';
import {
  DxPopupModule, DxTextAreaModule, DxFormModule, DxCheckBoxModule, DxDataGridModule, DxSelectBoxModule,
  DxNumberBoxModule, DxTextBoxModule, DxValidatorModule, DxDateBoxModule, DxButtonModule, DxLoadPanelModule, DxScrollViewModule
} from 'devextreme-angular';
import { SponsorDealerService } from './services/sponsor-dealer.service';
import { ActivityIndicatorComponent } from './components/activity-indicator/activity-indicator.component';
import { SponsorDealerComponent } from '../shared/components/sponsor-dealer/sponsor-dealer.component';
import { SponsorDealerConfirmationComponent } from './components/sponsor-dealer-confirmation/sponsor-dealer-confirmation.component';
import { SponsorDealerWaitComponent } from './components/sponsor-dealer/sponsor-dealer-wait/sponsor-dealer-wait.component';

const DEV_EXPRESS_COMPONENTS = [
  DxPopupModule, DxTextAreaModule, DxFormModule, DxCheckBoxModule, DxDataGridModule, DxSelectBoxModule,
  DxNumberBoxModule, DxTextBoxModule, DxValidatorModule, DxCheckBoxModule, DxDateBoxModule, DxButtonModule,
  DxLoadPanelModule, DxScrollViewModule
];

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ...DEV_EXPRESS_COMPONENTS
  ],
  providers: [HttpClientModule, SponsorDealerService],
  declarations: [ModalDialogComponent, ActivityIndicatorComponent, SponsorDealerComponent, SponsorDealerWaitComponent, SponsorDealerConfirmationComponent],
  exports: [
    ModalDialogComponent,
    SponsorDealerComponent,
    SponsorDealerWaitComponent,
    SponsorDealerConfirmationComponent,
    ...DEV_EXPRESS_COMPONENTS
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts